<template>
  <Anicss
    :enter-active-class="['animated', 'fadeIn']"
    :leave-active-class="['animated', 'fadeOut']"
  >
    <slot></slot>
  </Anicss>
</template>

<script>
import Anicss from '@/components/Anicss'

export default {
  components: {
    Anicss,
  },
}
</script>
